'use strict';

module.exports = function (keys) {
  var enumeration = {};

  keys.forEach(function (key) {
    enumeration[key] = key;
  });

  return enumeration;
};